export const PROJECTS = [
  {
    name: "Tinkering-Townsperson.github.io",
    repo: "https://github.com/Tinkering-Townsperson/Tinkering-Townsperson.github.io",
    description: "My personal portfolio website. Made with React.js and terminal.css, and hosted on GitHub Pages.",
    creation: "January 2024"
  },
  {
    name: "SpaceGoose",
    repo: "https://github.com/FraserHackClub/SpaceGoose",
    description: "A 2D platformer made for Hack Club's Juice Game Jam in April 2025.",
    creation: "February 2025"
  },
  {
    name: "fraser.hackclub.com",
    repo: "https://github.com/FraserHackClub/FraserHackClub.github.io",
    description: "The website for the student-run coding club Fraser Hack Club, based in Vancouver, BC.",
    creation: "December 2024"
  },
  {
    name: "UNDERTALE Manager",
    repo: "https://github.com/Tinkering-Townsperson/undertale_manager",
    description: "Manage multiple UNDERTALE save files!",
    creation: "November 2025"
  },
  {
    name: "Grid2Img",
    repo: "https://github.com/Tinkering-Townsperson/grid2img",
    description: "Revival and refactorization of my 2021 project \"Grid\". Converts a text file to a bitmap pixel art image.",
    creation: "December 2024"
  },
  {
    name: "Twin Chaser",
    repo: "https://github.com/Tinkering-Townsperson/daydream-project",
    description: "A 2-player platformer game where the players control two characters, inspired by my real life friends the twins, who chase each other around.",
    creation: "September 2025"
  },
  {
    name: "HackGrid",
    repo: "https://github.com/Tinkering-Townsperson/HackGrid",
    description: "The HackGrid is a custom keyboard that uses the MIDI protocol, one of my submissions to Hack Club's Highway in the Summer of 2025.",
    creation: "June 2025"
  },
  {
    name: "Nerf-Light",
    repo: "https://github.com/Tinkering-Townsperson/Nerf-Light",
    description: "A single-player version of red light, green light, made in Hack Club's Undercity Hackathon in July 2025.",
    creation: "July 2025"
  },
  {
    name: "Chunky",
    repo: "https://github.com/TinkerTown-SEMI/Chunky",
    description: "Chunky is a desktop assistant that breaks down assignments into manageable tasks, helping students stay focused and productive.",
    creation: "September 2024"
  },
  {
    name: "Undercity Lanyard Flasher",
    repo: "https://github.com/tinkering-townsperson/undercity-lanyard",
    description: "Undercity lanyard flasher, now with a GUI! Supports all platforms and makes images easy to add.",
    creation: "July 2025"
  },
  {
    name: "PyGrammaire",
    repo: "https://github.com/Tinkering-Townsperson/PyGrammaire",
    description: "Faisons de la grammaire! Les règles et les exceptions de la langue française, en forme de code!",
    creation: "November 2024"
  },
  {
    name: "Python Package Template",
    repo: "https://github.com/Tinkering-Townsperson/python_package_template",
    description: "A very customizable template for a Python package OR a package-ified Python app.",
    creation: "November 2023"
  },
  {
    name: "FizzBuzz",
    repo: "https://github.com/Tinkering-Townsperson/FizzBuzz",
    description: "My python implementation of FizzBuzz, a childhood game turned interview question.",
    creation: "August 2022"
  },
  {
    name: "SpaceName",
    repo: "https://github.com/Tinkering-Townsperson/spacename",
    description: "An alternative to dictionaries, built on the argparse Namespace class.",
    creation: "February 2023"
  },
  {
    name: "woodchopper",
    repo: "https://github.com/TinkerTown-SEMI/woodchopper",
    description: "A lightweight logging package for python featuring colourful prefixes and log level support.",
    creation: "July 2022"
  }
]
